<template>
	<input type="text"
		@focus="onFocus"
		@blur="onBlur"
		@keydown.enter="onKeyDown"
		@input="onInput" />
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Inputmask from 'inputmask'
import countryCodesTable from '../../assets/phone-codes.json'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'phoneComponent',

	//=========================================================================
	props: ['value', 'name'],

	//=========================================================================
	data() {
		return {
			Value: '',
			phoneCodes: countryCodesTable
		}
	},

	//=========================================================================
	created() {
		if (this.value && typeof this.value === 'string')
			this.Value = this.value.replace(/[+()_\s]/g, '')
	},

	//=========================================================================
	mounted() {
		this.$el.value = this.Value

		Inputmask({
			mask: () => this.mask(),
			skipOptionalPartCharacter: ' ',
			clearMaskOnLostFocus: true,
			greedy: false,
			placeholder: ' ',
			showMaskOnHover: false,
			undoOnEscape: false
		}).mask(this.$el)
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		searchPrefix() {
			for (let i = 4; i >= 1; i--)
			{
				let prefix = this.Value.substr(0, i)
				if (this.phoneCodes[prefix])
					return prefix
			}

			return ''
		},

		//---------------------------------------------------------------------
		mask() {
			let prefix = this.searchPrefix()
			let len = prefix.length
			let max = this.phoneCodes[prefix] && this.phoneCodes[prefix].max
				? this.phoneCodes[prefix].max : 0

			if (max === 10)
			{
				// # ### ######
				if (len === 1) return '+9 999 999999'
				// ## ### #####
				if (len === 2) return '+99 999 99999'
				// ### ## #####
				if (len === 3) return '+999 99 99999'
				// #### ## ####
				if (len === 4) return '+9999 99 9999'
			}
			else if (max === 11)
			{
				// # ### #######
				if (len === 1) return '+9 999 999999[9]'
				// ## ### ######
				if (len === 2) return '+99 999 99999[9]'
				// ### ### #####
				if (len === 3) return '+999 999 9999[9]'
				// #### ### ####
				if (len === 4) return '+9999 999 999[9]'
			}
			else if (max === 12)
			{
				// # #### #######
				if (len === 1) return '+9 9999 999999[9]'
				// ## #### ######
				if (len === 2) return '+99 9999 99999[9]'
				// ### #### #####
				if (len === 3)
				{
					if (prefix === '380') return '+999 999 99999[9]'
					return '+999 9999 9999[9]'
				}
				// #### #### ####
				if (len === 4) return '+9999 9999 999[9]'
			}
			else if (max === 13)
			{
				// # #### ########
				if (len === 1) return '+9 9999 9999999[9]'
				// ## #### #######
				if (len === 2) return '+99 9999 999999[9]'
				// ### #### ######
				if (len === 3) return '+999 9999 99999[9]'
				// #### #### #####
				if (len === 4) return '+9999 9999 9999[9]'
			}
			else if (max === 14)
			{
				// # #### #########
				if (len === 1) return '+9 9999 9999999[99]'
				// ## #### ########
				if (len === 2) return '+99 9999 999999[99]'
				// ### #### #######
				if (len === 3) return '+999 9999 99999[99]'
				// #### #### ######
				if (len === 4) return '+9999 9999 9999[99]'
			}

			return '+9999 9999 999999'
		},

		//---------------------------------------------------------------------
		onFocus() {
			this.$emit('focus')
		},

		//---------------------------------------------------------------------
		onBlur() {
			this.$emit('blur')
		},

		//---------------------------------------------------------------------
		onKeyDown(e) {
			this.$emit('keydownEnter')
		},

		//---------------------------------------------------------------------
		onInput(event) {
			let oldPrefix = this.searchPrefix()
			this.Value = this.$el.inputmask.unmaskedvalue()
			let newPrefix = this.searchPrefix()

			if (oldPrefix !== newPrefix)
			{
				this.$el.inputmask.option({ mask: this.mask() })
			}

			this.$emit('error', '')
			this.$emit('input', String(event.target.value).trim())
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// phone.vue?61b1c358